import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { UxModule } from '@app/shared/ux/ux.module';
import {
    WucBalloonModule,
    WucCardModule,
    WucIconUiModule,
    WucLinkModule,
    WucListItemModule,
    WucListModule,
    WucPageBlockModule,
    WucPriceModule,
    WucRackModule,
} from '@inshared/website-ui-components';
import { DirectControlButtonsModule } from '../direct-control-buttons/direct-control-buttons.module';
import { InsuranceDetailModule } from '../insurance-detail/insurance-detail.module';
import {
    InsuranceEndDateProductFormComponent,
    InsuranceEndProductComponent,
    InsuranceEndProductFormComponent
} from '../insurance-end-product';
import { InsuranceIMICModule } from '../insurance-imic/insurance-imic.module';
import { InsuranceRegularDriverFormModule } from '../insurance-regular-driver';
import { InsuranceListChangesComponent } from './insurance-list-changes/insurance-list-changes.component';
import { InsuranceListCoveragesComponent } from './insurance-list-coverages';
import { InsuranceListLinkComponent } from './insurance-list-link';
import { InsuranceListNoticeComponent } from './insurance-list-notice';
import { InsuranceListPriceComponent } from './insurance-list-price';
import { InsuranceListRelatedVehicleComponent } from './insurance-list-related-vehicle';
import { InsuranceListTitleComponent } from './insurance-list-title';
import { InsuranceListComponent } from './insurance-list.component';
import { InsuranceCoverageComponent, InsuranceCoverageFormComponent } from '../insurance-coverage';
import { InsuranceStartDateFormComponent } from '../insurance-start-date';

@NgModule({
    imports: [
        CommonModule,
        DirectControlButtonsModule,
        UxModule,
        PipesModule,
        DirectivesModule,
        RouterModule,
        InsuranceIMICModule,
        InsuranceDetailModule,
        InsuranceCoverageComponent,
        InsuranceRegularDriverFormModule,
        InsuranceEndProductComponent,
        WucIconUiModule,
        WucPageBlockModule,
        WucRackModule,
        WucPriceModule,
        WucListModule,
        WucListItemModule,
        WucCardModule,
        WucLinkModule,
        WucBalloonModule,
        InsuranceCoverageFormComponent,
        InsuranceStartDateFormComponent,
        InsuranceEndProductFormComponent,
        InsuranceEndDateProductFormComponent,
    ],
    exports: [InsuranceListComponent],
    declarations: [
        InsuranceListComponent,
        InsuranceListLinkComponent,
        InsuranceListRelatedVehicleComponent,
        InsuranceListTitleComponent,
        InsuranceListCoveragesComponent,
        InsuranceListNoticeComponent,
        InsuranceListChangesComponent,
        InsuranceListPriceComponent,
    ],
})
export class InsuranceListModule {}
